import { render } from "./Edit.vue?vue&type=template&id=52e6779a"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/classe/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52e6779a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52e6779a', __exports__)) {
    console.log('reload')
    api.reload('52e6779a', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=52e6779a", () => {
    console.log('re-render')
    api.rerender('52e6779a', render)
  })

}


export default __exports__